export enum ChatEventType {
  // When sent, this event creates a new message.
  // When received, it means a new message was created.
  //
  // NOTE: The send/receive message flow is *asyncrhonous*
  //    When sending a message, we don't receive a "reply" similar to HTTP mechanisms.
  //    Instead, the server will push a 'new_message' event of its own, with the newly created message.
  //    Clients should rely on received events as the source of truth.
  //
  // Multiple messages with the same ID can be received during the lifetime of the socket.
  //    This can happen when the AI Agent is streaming a response, or when loading the chat history.
  //    Messages with the same ID should only be displayed once.
  NewMessage = 'new_message',
  SendMessage = 'send_message',

  // Should be sent to the server once RefreshChatRooms is received
  JoinChatRooms = 'join_chat',
  JoinChatSuccess = 'join_chat_success',

  // Sent when an error occurs
  Error = 'error',

  // Agent Events
  AgentEvent = 'agent_event'
}
